/* Third-Party Notices: see THIRD_PARTY_NOTICES.md for licenses and attributions.

   This application includes permissively-licensed components (MIT, BSD-3, Apache-2.0). */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import './styles/global.css'
import i18n from './plugins/i18n'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

createApp(App).use(createPinia()).use(router).use(i18n).mount('#app')
